export function VoiceNewIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.5 8.3333L2.5 11.6666M5.83333 5.11162L5.83333 15.1116M9.16667 2.72327V17.7233M12.5 5.11163V6.77829M12.5 15.1116V13.445" stroke="#0D0D0D" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.833 7.92053C16.3183 8.79375 17.0381 9.51405 17.9111 9.99963C17.0384 10.485 16.3184 11.205 15.833 12.0778C15.3474 11.2047 14.6271 10.4849 13.7539 9.99963C14.6274 9.51409 15.3475 8.79404 15.833 7.92053Z" stroke="#0D0D0D" stroke-width="1.5" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "VoiceNewIcon";
